/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Col, Nav, NavItem, NavLink, Row, TabContent, TabPane} from 'reactstrap';
import i18n from "i18next";
import FanpageHearsCreateForm from "./FanpageHearsCreateForm";
import HearReplies from "../../Hear/HearReplies";

class FanpageHearsTabs extends Component {
    constructor(props) {
        super(props);


        this.state = {
            activeTab: new Array(4).fill('1'),
            repliesData: [],
            hear: this.props.hear,
            hearId: this.props.hearId,
            fanpageId: this.props.fanpageId,
        };
    }

    componentDidMount() {
        let hearId = this.props.hearId;
        let hear = this.props.hear;
        this.loadHear(hearId, hear);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let hearId = nextProps.hearId;
        let hear = nextProps.hear;
        this.loadHear(hearId, hear);
    }

    loadHear(hearId, hear) {
        if (hearId === undefined) {
            this.toggle(2, '1');
        } else {
            this.toggle(2, '2');
        }

        this.setState({hearId: hearId, hear: hear});
    }

    toggle(tabPane, tab) {
        const newArray = this.state.activeTab.slice();
        newArray[tabPane] = tab;
        this.setState({
            activeTab: newArray,
        });
    }

    formCreateHear() {
        return (<FanpageHearsCreateForm fanpageId={this.props.fanpageId}/>);
    }

    tabPane() {
        return (
            <>
                <TabPane tabId="1">
                    {this.formCreateHear()}
                </TabPane>
                <TabPane tabId="2">
                    <HearReplies fanpageId={this.state.fanpageId} hearId={this.state.hearId}/>
                </TabPane>
            </>
        );
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col xs="12" md="12" className="mb-4">
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    active={this.state.activeTab[2] === '1'}
                                    onClick={() => {
                                        this.toggle(2, '1');
                                    }}
                                >
                                    <i className="fa fa-plus"> </i> <span
                                    className={this.state.activeTab[2] === '1' ? '' : 'd-none'}> {i18n.t("Create")}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem className={this.state.hearId === undefined ? 'hide' : ''}>
                                <NavLink
                                    active={this.state.activeTab[2] === '2'}
                                    onClick={() => {
                                        this.toggle(2, '2');
                                    }}
                                >
                                    <i className="fa fa-edit"> </i> <span
                                    className={this.state.activeTab[2] === '2' ? '' : 'd-none'}> {this.state.hear}</span>
                                </NavLink>
                            </NavItem>

                        </Nav>
                        <TabContent activeTab={this.state.activeTab[2]}>
                            {this.tabPane()}
                        </TabContent>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default FanpageHearsTabs;

